"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTextareaMarkdownOptions = exports.BUILT_IN_COMMANDS = void 0;
exports.BUILT_IN_COMMANDS = [
    'bold',
    'italic',
    'strike-through',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'unordered-list',
    'ordered-list',
    'code-block',
    'code-inline',
    'code',
    'link',
    'image',
    'block-quotes',
];
exports.defaultTextareaMarkdownOptions = {
    preferredUnorderedListSyntax: '-',
    preferredBoldSyntax: '**',
    preferredItalicSyntax: '*',
    enableIndentExtension: true,
    enableLinkPasteExtension: true,
    enablePrefixWrappingExtension: true,
    enableProperLineRemoveBehaviorExtension: true,
    enableOrderedListAutoCorrectExtension: false,
    customPrefixWrapping: [],
    boldPlaceholder: 'bold',
    italicPlaceholder: 'italic',
    strikeThroughPlaceholder: 'strike through',
    codeInlinePlaceholder: 'code',
    codeBlockPlaceholder: 'code block',
    orderedListPlaceholder: 'ordered list',
    unorderedListPlaceholder: 'unordered list',
    headlinePlaceholder: function (lvl) { return "headline ".concat(lvl); },
    blockQuotesPlaceholder: 'quote',
    linkTextPlaceholder: 'example',
    linkUrlPlaceholder: 'url',
    imageTextPlaceholder: 'example',
    imageUrlPlaceholder: 'image.png',
};
